import { render, staticRenderFns } from "./nav-menu.vue?vue&type=template&id=10ae274b&scoped=true&"
import script from "./nav-menu.vue?vue&type=script&lang=js&"
export * from "./nav-menu.vue?vue&type=script&lang=js&"
import style0 from "./nav-menu.vue?vue&type=style&index=0&id=10ae274b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae274b",
  null
  
)

component.options.__file = "nav-menu.vue"
export default component.exports